import useProjectDomains from "../../../../api/utilities/useProjectDomains.js";
import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import Creatable from "react-select/creatable";
import {useEffect, useMemo, useState} from "react";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectApi} from "../../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";

export default function HostNameAndCsvLinkList({project, projectIntegration, value, onChange}) {
    let {t} = useTranslation();
    let authorityConfiguration = useAuthorityConfiguration();

    let projectDomains = useProjectDomains(project);
    let [projectDomainNamesWithCsvLinks, setProjectDomainNamesWithCsvLinks] = useState(null);

    useEffect(() => {
        if (projectIntegration === null) {
            setProjectDomainNamesWithCsvLinks([]);
            return;
        }

        new ProjectApi(authorityConfiguration)
            .hostNameAndCSVLink({
                integrationId: projectIntegration.id
            })
            .then(setProjectDomainNamesWithCsvLinks)
            .catch(() => setProjectDomainNamesWithCsvLinks([]));
    }, [project.id, projectIntegration?.id]);

    useEffect(() => {
        onChange(projectDomainNamesWithCsvLinks);
    }, [projectDomainNamesWithCsvLinks]);

    let hostNameOptions = useMemo(() => {
        if (projectDomains === null) {
            return [];
        }
        return projectDomains.map((projectDomain) => ({
            value: projectDomain.projectDomain.hostName,
            label: projectDomain.projectDomain.hostName
        }));
    }, [projectDomains]);

    return <LoadingComponent
        className={'border-1 p-3 border-slate-500 rounded'}
        loading={projectDomainNamesWithCsvLinks === null}
    >
        {projectDomains === null && <Spinner/>}
        {projectDomains && <div>
            {(value ?? []).map((row, index) => {
                return <div className={'flex gap-2 pt-2'} key={'xml-link-row-' + index}>
                    <Creatable
                        value={{label: row.hostName, value: row.hostName}}
                        className={'w-4/12'}
                        onChange={(e) => {
                            value[index] = {...row, hostName: e.value};
                            onChange(value);
                        }}
                        options={hostNameOptions}
                    />
                    <input
                        value={row.csvLink}
                        className={'w-7/12 form-input'}
                        type={'text'}
                        onChange={(e) => {
                            value[index] = {...row, csvLink: e.target.value};
                            onChange(value);
                        }}
                    />
                    <Button
                        className={'button button-danger-outline w-1/12'}
                        onClick={() => {
                            //delete value[index];
                            onChange(value.filter((x, checkedIdx) => index !== checkedIdx));
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashCan}/>
                    </Button>
                </div>;
            })}
        </div>}
        <div className={'pt-2'}>
            <Button
                className={'button button-success-outline'}
                onClick={() => {
                    onChange([...value, {hostName: '', csvLink: ''}]);
                }}
            >
                {t('add-hostname-and-csv-link')}
            </Button>
        </div>
    </LoadingComponent>;
}